import {
  backButton,
  hapticFeedback,
  init,
  initData,
  miniApp,
  retrieveLaunchParams,
  setDebug,
  themeParams,
  viewport,
} from '@telegram-apps/sdk-react';
import { initTheme } from './theme';

/**
 * Telegram bridge bormi: mobil/desktop — `TelegramWebviewProxy`, web.telegram.org — iframe.
 * `isTMA()` ishlatilmaydi: u sessionStorage'dagi launch params'ni ham "Telegram" deb biladi.
 */
export const insideTelegram = () => 'TelegramWebviewProxy' in window || window.parent !== window;

const step = (name: string, fn: () => void) => {
  try {
    fn();
  } catch (e) {
    console.error(`[telegram] ${name} failed`, e);
  }
};

/**
 * Telegram SDK komponentlarini ulaydi. main.tsx dan bir marta chaqiriladi.
 * Ixtiyoriy qadamlar xatosi ilovani to'xtatmaydi — faqat logga yoziladi.
 */
export async function initTelegram(debug: boolean): Promise<void> {
  setDebug(debug);
  init();

  step('backButton', () => backButton.mount.ifAvailable());
  step('initData', () => initData.restore());
  step('theme', () => {
    if (!miniApp.mountSync.isAvailable()) return;
    themeParams.mountSync();
    miniApp.mountSync();
    themeParams.bindCssVars();
  });
  // Brend temasi (ranglar o'zimizniki; Telegram'dan faqat qorong'i/yorug' tanlovi).
  step('brandTheme', initTheme);

  // Viewport javobi kelmasa ham ilova ochilishi kerak — 2 s dan keyin davom etamiz.
  if (viewport.mount.isAvailable()) {
    await Promise.race([
      viewport
        .mount()
        .then(() => {
          viewport.bindCssVars();
          viewport.expand();
        })
        .catch((e: unknown) => console.error('[telegram] viewport failed', e)),
      new Promise((resolve) => setTimeout(resolve, 2000)),
    ]);
  }

  step('ready', () => miniApp.ready.ifAvailable());
}

export const getLaunchParams = () => retrieveLaunchParams();

/** Asosiy amallar uchun haptic (SPEC §11). */
export const haptic = {
  success: () => hapticFeedback.notificationOccurred.ifAvailable('success'),
  error: () => hapticFeedback.notificationOccurred.ifAvailable('error'),
  tap: () => hapticFeedback.impactOccurred.ifAvailable('light'),
};
